import React, { useState ,useEffect} from 'react';

import '../../Assets/css/custom.css';
import '../../Assets/css/w3-css.css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";   

import CommonAPI from '../../Common/CommonAPI';
import CommonAPI2 from '../../Common/FD_BILL_APIs';
import FadeLoader from "react-spinners/HashLoader"; 
import BillHistoryDetailPage from "./BillHistoryDetails"; 
import moment from 'moment';
import { Table } from 'react-bootstrap';
import downloadpng from "../../images/download.png";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';



function BillHistory (props)  {  

 const [ SuccessLoading,setSuccessLoading] = useState(false);    
  const [BillType,setBillType] = useState([]); 
  const [RegSelectedBill,setRegSelectedBill] = useState();
  const [RegesterBillTypeName,setRegesterBillTypeName] = useState();
  const [BillRegisterType,setBillRegisterType] = useState();
  const [BillingCode,setBillingCode] = useState();
  const [BillingAccount,setBillingAccount] = useState();
  const [BillServiceProvider,setBillServiceProvider] = useState([]);
  const [Password,setPassword] = useState();
  const [RegServiceProviderCode,setRegServiceProviderCode] = useState("");
  const [RegServiceProviderName,setRegServiceProviderName] = useState();
  const [SuccessfulMSG,setSuccessfulMSG] = useState();
  const [ErrorMSG,setErrorMSG] = useState();
  const [BillList,setBillList] = useState([]);
  const [BillDetail,setBillDetail] = useState(false);
  const [StartDate,setStartDate] = useState(new Date().setMonth(new Date().getMonth()+(-1)));  
  const [EndDate,setEndDate] = useState(new Date());
  const [ SuccessDownload,setSuccessDownload] = useState(false);
  
    const BillTypeAPI = ()=>{
        CommonAPI2.BillPaymentType((result)=>{
          setBillType(result);
        }
       )
      }

    useEffect( () => {
        BillTypeAPI(); 
        GetBillHistoryAPI();       
      },[]);

     
    const GetBillHistoryAPI =() => {
        setSuccessLoading(true);
    var Sdate  = StartDate?moment(StartDate).format('DD-MM-YYYY'):"";
    var Edate  = EndDate?moment(EndDate).format('DD-MM-YYYY'):"";
    var WithPara = RegServiceProviderCode||Sdate||Edate?('providerCode='+RegServiceProviderCode+'&startDate='+Sdate+'&endDate='+Edate):"";
    var WithTypePara = RegServiceProviderCode||Sdate||Edate?('startDate='+Sdate+'&endDate='+Edate+'&type='+BillRegisterType):"";

    CommonAPI2.GetBillHistory(
            {
            RegServiceProviderCode:RegServiceProviderCode,
            BillRegisterType:BillRegisterType,               
            WithPara,
            WithTypePara
        },(result)=>{
           setBillList(result);
           setSuccessLoading(false);
        });
    }

    const ResponseLoadingModal = () => {
        return(
            <Modal
            size="lg"
            centered 
            className="loading1" show={SuccessLoading}>          
                  <FadeLoader
                  height={25}
                  width={5}
                  radius={2}
                  margin={2}
                  color={"#197b55"}
                  size={"80px"} this also works
                  loading={SuccessLoading}
                />       
           </Modal>
         )
    }

    const GetBillingAccount = (type)=> {
        var passValFrom = JSON.parse(type.target.value);  
        setBillServiceProvider([]);
        setRegServiceProviderCode("");
        if(passValFrom ==='Select Bill'){
        setRegSelectedBill('');
        setRegServiceProviderCode("");
        }else{
            setRegSelectedBill(passValFrom.type)
        }

        setRegesterBillTypeName(passValFrom.name);
        setBillRegisterType(passValFrom.type);  
        if(passValFrom.type){
            GetServiceProviderForRegAPI(passValFrom.type)
          }
        }
      
    const GetServiceProviderForRegAPI = (type) =>{
        CommonAPI2.GetServiceProviderForReg({type:type},(result)=>{
        result.map((list,index)=>{        
            setBillingCode(list.code);
            setBillServiceProvider(result);        
        })
        })
    }
    const RegServiceProvider = (type) =>{
        var BillingCodeVal = JSON.parse(type.target.value);    
            setRegServiceProviderName(BillingCodeVal.name);
            setRegServiceProviderCode(BillingCodeVal.code);
     }

    const BillDetails =(ind)=>{
        var BillInfor = {
            BillRef: ind.id,
            BillReference:ind.billRef,
        }
        var value = JSON.stringify(BillInfor);
        sessionStorage.setItem('BillValues', value );
        setBillDetail(true);

        var DatesInfor = {
            StartSaveDate: StartDate?moment(StartDate).format('x'):"",
            EndSaveDate:EndDate?moment(EndDate).format('x'):"",
        }
    
        var dates = JSON.stringify(DatesInfor);
        sessionStorage.setItem('DateInfo', dates );
    }
    const BillHistoryDetailToggleModal = () => {
        setBillDetail(!BillDetail);
    }
    const printDocument =()=>{
        return (
        <Modal
            size="xl"
            centered         
            onHide={()=>setSuccessDownload(!SuccessDownload)}       
            aria-labelledby="contained-modal-title-vcenter"        
            backdrop="static"
            show={SuccessDownload}> 
    
         <Modal.Header closeButton>
            <Modal.Title className='hselect' id="contained-modal-title-vcenter">
            <p className='modal-head-f'>BILL PAYMENT</p><br/>HISTORY
            </Modal.Title>
            <div>
                <img className='downlogo' onClick ={DownloadDocument.bind(this)} src={downloadpng} alt="download" />
            </div>
          </Modal.Header>
          
          <Modal.Body>
                    
                <Row lg={12} className='div-background'>
                    <Col lg={12} className='rmv-pad3 block text-color'>
    
                    <Table id="divToPrint" className='block-top' hover responsive>
                        <thead >
                            <tr>
                            <th className='td-width5'>Reference Number</th>
                            <th className='td-width5'>Payment On</th>
                            <th className='td-width5'>Amount LKR</th>
                            <th className='td-width5'>Billing Type</th>
                            <th className='td-width5'>Service Provider</th>
                            <th className='td-width5'>Billing Account</th>
                            <th className='td-width5' >Pay Status</th>
                            <th className='td-width5'> Your Reference</th>
                            <th className='td-width5'>Pay By Account</th>
                            <th className='td-width5'> Bill Enter Date </th>
                            <th className='td-width5'> Bill Suspend Date </th>
                           
                            </tr>
                        </thead>
                        <tbody className='heightTable'>
                        {BillList.length>0?BillList.map(( listValue, index ) => {
                       return( 
                        <tr>
                            <td className='td-width5'>
                                <p className='tb-text m-top'>{listValue.billRef}</p>
                            </td>
                            <td className='td-width5'>
                                <p className='tb-text m-top'>{moment(listValue.dueDate).format('DD/MM/YYYY')}</p>
                            </td>
                            <td className='td-width5'>
                                <p className='tb-text m-top'>{listValue.payAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </td>
                            <td className='td-width5'>
                                <p className='tb-text m-top'>{listValue.billType}</p>
                            </td>
                            <td className='td-width5'>
                                <p className='tb-text m-top'>{listValue.provider}</p>
                            </td>
                            <td className='td-width5'>
                                <p className='tb-text m-top'>{listValue.billingAccount}</p>
                            </td>
                            <td className='td-width5'>
                                <p className='tb-text m-top'>{listValue.billStat=="A"?"Active":listValue.billStat=="S"?"Suspend":listValue.billStat=="R"?"Return":null}</p>
                            </td>
                            <td className='td-width5'>
                                <p className='tb-text m-top'>{listValue.bankReference?((listValue.bankReference.length>14)?(listValue.bankReference.substring(0,12)+"\n"+listValue.bankReference.substring(12,28)):listValue.bankReference):"-"}</p>
                            </td>
                            <td className='td-width5'>
                                <p className='tb-text m-top'>{listValue.accountNo}</p>
                            </td>
                            <td className='td-width5'>
                                <p className='tb-text m-top'>{moment(listValue.enterDate).format('DD/MM/YYYY')}</p>
                            </td>
                            <td className='td-width5'>
                                <p className='tb-text m-top'>{listValue.suspendDate?moment(listValue.suspendDate).format('DD/MM/YYYY'):"-"}</p>
                            </td>
                                                              
                        </tr>
                       )
                        }):
                        <Row className='tablebody'>
                            <p className='h-text block-top'>No Records</p>
                        </Row>
                    }  
                        </tbody>
                </Table>
                    </Col>
                </Row>
            
        </Modal.Body>        
        </Modal>
            );
        }

    const DownloadDocument =()=> {        
        const input = document.getElementById('divToPrint');
        html2canvas(input)
          .then((canvas) => {
            var imgWidth = 210;
            var pageHeight = 295;
            var imgHeight = canvas.height * imgWidth / canvas.width;
            var heightLeft = imgHeight;
            var position = 0;
  
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', [290, 210]);
            pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
            while (heightLeft >= 0) {
                 position = heightLeft - imgHeight;
                 pdf.addPage();
                 pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                 heightLeft -= pageHeight;
               }
            //pdf.output('dataurlnewwindow');
            pdf.save("BillPaymentsHistory.pdf");
          })
        ;
       }

    if(SuccessLoading){
        return ( <div>{ResponseLoadingModal()}</div> );
      }
        return (
            <div>
                {SuccessDownload?printDocument():null}
                <Row className='block'>
                    <p className='p-line2'>BILL PAYMENTS HISTORY</p>
                </Row>
                {BillDetail?
                <BillHistoryDetailPage isOpen={BillDetail} toggle={BillHistoryDetailToggleModal} />
                :null
                }
                <Form >
                    <Row>
                        <Col md={3} xs={12}>
                            <Form.Group as={Row} className="mb-1">
                                <Form.Label className="c-font" column sm={5}>
                                    PAYMENT TYPE
                                </Form.Label>
                                <Col sm={7} >
                                    <Form.Select 
                                        onChange={GetBillingAccount.bind(this)}
                                        size="sm" 
                                        className="form-h2 ">
                                            <option value={JSON.stringify("Select Bill")}>Select</option>
                                            {BillType?BillType.map((listValue,index)=> {
                                            return(<option key={index} value={JSON.stringify(listValue)}>{listValue.name}</option>)
                                            }):null
                                            }                           
                                        </Form.Select>
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col md={3} xs={12}>
                            <Form.Group as={Row} className="mb-1">
                                <Form.Label className="c-font" column sm={4}>
                                    PROVIDER
                                </Form.Label>
                                <Col sm={8} >
                                    <Form.Select 
                                        onChange={RegServiceProvider.bind(this)}
                                        size="sm" className="form-h2 ">
                                        <option value={JSON.stringify("Select Service Provider")}>-Select Service Provider-</option>
                                        {BillServiceProvider.map((ListValue,index)=> {
                                            return(<option key={index} value={JSON.stringify(ListValue)}>{ListValue.name} </option>)
                                        })
                                        }
                                        </Form.Select>
                                </Col>  
                            </Form.Group>
                        </Col>
                        <Col md={2} xs={12}>
                            <Form.Group as={Row} className="mb-1">
                                <Form.Label className="d-flex c-font line-up" column sm={6}>
                                    START DATE
                                </Form.Label>
                                <Col sm={6}  className="line-up">
                                    <DatePicker
                                        className="datepicker3"
                                        selected={StartDate}
                                        onChange={(e)=>setStartDate(e)}
                                        dateFormat="dd/MM/yyyy"                                
                                />
                                </Col>
                            </Form.Group>
                        </Col> 
                        <Col md={2} xs={12}>
                            <Form.Group as={Row} className="mb-1">
                                <Form.Label className="c-font line-up" column sm={6}>
                                        END DATE
                                </Form.Label>
                                <Col sm={6} className="line-up">
                                    <DatePicker
                                        className="datepicker3"
                                        selected={EndDate}
                                        onChange={(e)=>setEndDate(e)}
                                        dateFormat="dd/MM/yyyy"                                
                                    />
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col md={2} xs={12}>
                            <Form.Group as={Row} className="mb-1 top-div">
                                <Col className="d-flex align-items-center justify-content-between line-up" >                             
                                    <Button 
                                    onClick={()=>GetBillHistoryAPI()}
                                    className='btn-browse' variant="primary" type="submit">
                                        SEARCH
                                    </Button>
                                    <img className='downlogo' 
                                    onClick ={()=>setSuccessDownload(true)} 
                                    src={downloadpng} alt="download" />                                                                                       
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>


                    {/* <Form.Group as={Row} >
                    
                        <Form.Label className="c-font2" column sm={1}>
                            PAYMENT TYPE
                        </Form.Label>
                        <Col sm={2} >
                             <Form.Select 
                                onChange={GetBillingAccount.bind(this)}
                                size="sm" 
                                className="form-h2 ">
                                    <option value={JSON.stringify("Select Bill")}>Select</option>
                                    {BillType?BillType.map((listValue,index)=> {
                                    return(<option key={index} value={JSON.stringify(listValue)}>{listValue.name}</option>)
                                    }):null
                                    }                           
                                </Form.Select>
                        </Col>
                                               
                        <Form.Label className="c-font" column sm={1}>
                            PROVIDER
                        </Form.Label>
                        <Col sm={2} >
                             <Form.Select 
                                onChange={RegServiceProvider.bind(this)}
                                size="sm" className="form-h2 ">
                                <option value={JSON.stringify("Select Service Provider")}>-Select Service Provider-</option>
                                {BillServiceProvider.map((ListValue,index)=> {
                                    return(<option key={index} value={JSON.stringify(ListValue)}>{ListValue.name} </option>)
                                })
                                }
                                </Form.Select>
                        </Col>                        
                        
                        <Form.Label className="d-flex justify-content-center t-right c-font line-up" column sm={1}>
                            START DATE
                        </Form.Label>
                        <Col sm={1}  className="line-up">
                            <DatePicker
                                className="datepicker3"
                                selected={StartDate}
                                onChange={(e)=>setStartDate(e)}
                                dateFormat="dd/MM/yyyy"                                
                        />
                        </Col>
                        
                        <Form.Label className="c-font t-right line-up" column sm={1}>
                                END DATE
                        </Form.Label>
                        <Col sm={1} className=" t-left line-up">
                            <DatePicker
                                className="datepicker3 "
                                selected={EndDate}
                                onChange={(e)=>setEndDate(e)}
                                dateFormat="dd/MM/yyyy"                                
                            />
                        </Col>
                                       
                        <Col className="d-flex align-items-center justify-content-between line-up" >                             
                            <Button 
                            onClick={()=>GetBillHistoryAPI()}
                            className='btn-browse' variant="primary" type="submit">
                                SEARCH
                            </Button>
                            <img className='downlogo' 
                            onClick ={()=>setSuccessDownload(true)} 
                            src={downloadpng} alt="download" />                                                                                       
                        </Col>
                    </Form.Group>                                                                 */}
                </Form>
                <div className="tableFixHead block">
                <Table   hover responsive>
                    <thead >
                        <tr>
                        <th className='td-width5 t-left'>Reference Number</th>
                        <th className='td-width5 t-left'>Payment<br/> On</th>
                        <th className='td-width5 t-left'>Amount <br/>LKR</th>
                        <th className='td-width5 t-left'>Billing<br/> Type</th>
                        <th className='td-width4 t-left'>Service<br/> Provider</th>
                        <th className='td-width2 t-left'>Billing <br/>Account</th>
                        <th className='td-width10 t-right' >Pay<br/> Status</th>
                        <th className='td-width10 t-right'> Your<br/> Reference</th>
                        <th className='td-width10 t-right'>Pay By <br/>Account</th>
                        <th className='td-width5 t-right'> Bill Enter<br/> Date </th>
                        <th className='td-width5 t-right'> Bill Suspend<br/> Date </th>
                        <th ><div className='td-width10 t-right'></div> </th>
                        </tr>
                    </thead>
                    <tbody >
                    {BillList.length>0?BillList.map(( listValue, index ) => {
                    return( 
                    <tr >
                        <td className='td-width5'>
                            <p className='tb-text m-top t-left'>{listValue.billRef}</p>
                        </td>
                        <td className='td-width5'>
                            <p className='tb-text m-top t-left'>{moment(listValue.dueDate).format('DD/MM/YYYY')}</p>
                        </td>
                        <td className='td-width5'>
                            <p className='tb-text m-top t-left'>{listValue.payAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                        </td>
                        <td className='td-width5'>
                            <p className='tb-text m-top t-left'>{listValue.billType}</p>
                        </td>
                        <td className='td-width4'>
                            <p className='tb-text m-top t-left'>{listValue.provider}</p>
                        </td>
                        <td className='td-width2'>
                            <p className='tb-text m-top t-left'>{listValue.billingAccount}</p>
                        </td>
                        <td className='td-width10'>
                            <p className='tb-text m-top t-right'>{listValue.billStat=="A"?"Active":listValue.billStat=="S"?"Suspend":listValue.billStat=="R"?"Return":null}</p>
                        </td>
                        <td className='td-width10'>
                            <p className='tb-text m-top t-right'>{listValue.bankReference?((listValue.bankReference.length>14)?(listValue.bankReference.substring(0,12)+"\n"+listValue.bankReference.substring(12,28)):listValue.bankReference):"-"}</p>
                        </td>
                        <td className='td-width10'>
                            <p className='tb-text m-top t-right'>{listValue.accountNo}</p>
                        </td>
                        <td className='td-width5 '>
                            <p className='tb-text m-top t-right'>{moment(listValue.enterDate).format('DD/MM/YYYY')}</p>
                        </td>
                        <td className='td-width5'>
                            <p className='tb-text m-top t-right'>{listValue.suspendDate?moment(listValue.suspendDate).format('DD/MM/YYYY'):"-"}</p>
                        </td>
                        <td className='td-width10 t-right'>
                            <Button 
                            onClick={()=>{BillDetails(listValue)}}
                            className='btn-browse' 
                            variant="primary" type="submit">
                                Details
                            </Button>
                        </td>                                    
                    </tr>
                    )
                    }):
                    <tr  className='tr-h'>
                        <td colspan="12"><p className='t-center block-top'>No Records</p></td>
                    </tr> 
                }  
                    </tbody>
                </Table> 
                </div>                
            </div>
          );
    }

export default BillHistory;